import { useEffect, useCallback } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

interface QRModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

export default function QRModal({ isOpen, onClose, url }: QRModalProps) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="card max-w-sm w-full mx-4 flex flex-col items-center">
        <div className="flex justify-between items-center w-full mb-4">
          <h3 className="heading text-lg font-semibold text-dnd-fg">Share Campaign</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close QR code modal"
            className="btn btn-secondary text-sm"
          >
            Close
          </button>
        </div>
        <div className="bg-white p-4 rounded">
          <QRCodeCanvas value={url} size={200} />
        </div>
        <p className="mt-4 text-sm text-dnd-muted break-all text-center">{url}</p>
      </div>
    </div>
  );
}
